import * as util from '../base/util';
import TaskRunner from '../base/TaskRunner';

TaskRunner.add(() => {
    // Кастомный vh
    util.refreshCustomVH();

    window.addEventListener('resize', () => {
        util.refreshCustomVH();
    });

    document.documentElement.style.setProperty('--scrollbarWidth', util.getScrollbarWidth() + 'px');
});